"use client"

import Container from "@/components/UI/Containers/Container"
import Footer from "@/components/UI/footer/footer"
import Topbar from "@/components/UI/navbar/topbar"
import SearchElement from "@/components/UI/search/searchElement"
import { useRouter } from "next/navigation"
import {SEOUtil} from "@/utils/SEOUtil";
import Image from "next/image";

export default function Nawigator() {
  const router = useRouter()

  return (
    <>
      <SEOUtil name="Nawigator" url="/app/nawigator" description="Odkryj najlepsze szkoły i kierunki w swoim regionie i otwórz drzwi do nowych możliwości." mainEntityOfPage page />
      <Topbar />
      <main>
        <div className="relative w-full h-[90vh]">
          <Image
            src="/nawigator/baner.webp"
            alt="Tło nawigator"
            fill
            priority
            style={{objectFit: "cover", zIndex: 0}}
          />
          <section
            className='absolute inset-0 text-white5 flex flex-col justify-center items-center w-full h-full overflow-hidden bg-cover bg-no-repeat bg-center '
            style={{
              background: "linear-gradient(rgba(34, 34, 34, 0.6), rgba(34, 34, 34, 0.6))",
              zIndex: 1,
            }}>
            <Container className='flex flex-col items-center justify-center max-sm:flex-col gap-10 '>
              <h1 className='text-white16 font-black mb-12 text-[4.2rem] leading-[1.05] tracking-[-0.5px] fadeIn text-center'>
                Wyszukaj region w którym mieszkasz
              </h1>
              <form className='w-1/2'>
                <SearchElement
                  apiUrl='districts'
                  placeholder="Wyszukaj region"
                  onSelect={function (el: { id: string; name: string }): void {
                    router.push(`/app/nawigator/${el.id}`)
                  }}
                />
              </form>
            </Container>
          </section>
        </div>
      </main>
      <Footer />
    </>
  )
}
